import React from 'react';
import { Card, Row, Col, Icon } from 'antd';
import { PhotoImage, PhotoPlaceholder } from "../../common/photoImage/photoImage";
import { EditButton } from '../../common/editButton/editButton'
import './successReportCard.css';

const DeleteButton = ({onClick}) => (
  <div className="list__delete-button" onClick={onClick}>
    Delete
    <Icon type="delete" className="list__delete-icon" />
  </div>
);

export const SuccessReportInfoCard = ({report, editLink, onClick, children}) => {
  return (
    <Card className="success-report_card">
      <Row className="success-report-card__layout" type="flex">
        <Col xs={{span: 24, order: 1}} sm={{span: 10, order: 0}} lg={{span: 2}} className="success-report-card__sider">
          <div className="success-report-card__photo-wrapper">
            { report.author.photo.small ? <PhotoImage imageURL={report.author.photo.small}/> : <PhotoPlaceholder/> }
          </div>
        </Col>
        <Col xs={{span: 24, order: 0}} sm={{span: 14}} lg={{span: 21, offset: 1}}>
          <Col xs={{span: 0, order: 1}} lg={{span: 16, order: 0}}>
            { children }
          </Col>
          <Col xs={{span: 24, order: 0}} lg={{span: 8, order: 1}} className="success-report__control-buttons">
            { (report.editable) && <EditButton link={editLink} className="list__edit-button"/> }
            { (report.deletable) && <DeleteButton onClick={onClick} /> }
          </Col>
        </Col>
        <Col xs={{span: 24, order: 2}} lg={{span: 0}}>
          { children }
        </Col>
      </Row>
    </Card>
  );
};

export const SuccessReportFormCard = ({ photo, children }) => {
  return (
    <Card className="success-report_card">
      <Row className="success-report-card__layout" type="flex">
        <Col xs={{span: 24}} sm={{span: 10}} lg={{span: 2}} className="success-report-card__sider">
          <div className="success-report-card__photo-wrapper">
            { photo ? <PhotoImage imageURL={photo}/> : <PhotoPlaceholder/> }
          </div>
        </Col>
        <Col xs={{span: 24}} sm={{span: 14}} lg={{span: 21, offset: 1}}>
          { children }
        </Col>
      </Row>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/successReports/successReportCard.js